// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"bcf9f605","188":"f5843171","453":"bde7369f","638":"23218735","708":"d4819316","753":"423751dc","836":"819fa9e7","946":"814ebed8"}[chunkId] + ".chunk.js";
};